// Shared constants & helpers for Policies pages
export const POLICY_TYPES = [
  { v: "auto", l: "Auto" }, { v: "moto", l: "Moto" }, { v: "natante", l: "Natante" }, { v: "casa", l: "Casa" }, { v: "vita", l: "Vita" },
  { v: "salute", l: "Salute" }, { v: "infortuni", l: "Infortuni" },
  { v: "viaggio", l: "Viaggio" }, { v: "responsabilita_civile", l: "Responsabilità civile" },
];

// 🆕 30/07/2026 — Opzioni per polizze Natante (imbarcazioni)
export const BOAT_ENGINE_INSTALL_OPTIONS = ["Fuoribordo", "Entrobordo", "Entro fuoribordo"];
export const BOAT_ENGINE_FUEL_OPTIONS = ["Benzina", "Diesel"];
export const BOAT_HULL_MATERIAL_OPTIONS = ["Vetroresina", "Legno", "Alluminio", "Acciaio", "Gommone", "PVC", "Altro"];

// Brand di moto noti — usato per auto-classificare il tipo polizza come "moto"
// quando l'operatore inserisce un brand a due ruote.
export const MOTO_BRAND_REGEX = /^(ducati|aprilia|yamaha|kawasaki|harley[\s-]?davidson|harley|triumph|piaggio|vespa|bmw motorrad|moto guzzi|guzzi|ktm|husqvarna|benelli|mv agusta|royal enfield|peugeot motocycles|kymco|sym|sherco)$/i;
// Quick check helper
export const isMotoBrand = (brand) => !!brand && MOTO_BRAND_REGEX.test(String(brand).trim());

// 🆕 Feb 2026 — Lista completa allineata al backend `PolicyStatus` (server.py:1971).
// Include: rinnovata, in_emissione, sostituita_riattivazione (aggiunti dopo il fix
// del ValidationError su PolicyOut serializzando polizze legacy in DB).
export const POLICY_STATUSES = [
  "attiva",
  "in_scadenza",
  "scaduta",
  "sospesa",
  "disdetta",
  "rinnovata",
  "in_emissione",
  "sostituita",
  "sostituita_riattivazione",
];

export const FRAZIONAMENTI = [
  { v: "annuale", l: "Annuale (12 mesi)", months: 12 },
  { v: "semestrale", l: "Semestrale (6 mesi)", months: 6 },
  { v: "quadrimestrale", l: "Quadrimestrale (4 mesi)", months: 4 },
  { v: "trimestrale", l: "Trimestrale (3 mesi)", months: 3 },
  { v: "mensile", l: "Mensile", months: 1 },
];

export const POLICY_EMPTY = {
  client_id: "", policy_number: "", type: "auto", company: "", company_id: "",
  broker_id: "", premium: 0, taxable_base: "", imposte_amount: "", ssn_amount: "", commission_percent: "", commission_amount: "", commission_cost: "", policy_cost: "", broker_fixed_fee: "",
  product_id: "", product_buy_cost: "", product_sell_cost: "",
  extra_fees_total: "", include_extra_in_statement: false, include_broker_fixed_fee_in_statement: true, exclude_extra_fees_from_statement: false, exclude_broker_fixed_from_statement: false,
  agent_id: "",
  show_vehicle_data: false,
  frazionamento: "annuale", start_date: "", end_date: "", start_time: "24:00", end_time: "24:00", status: "attiva",
  vehicle_plate: "", vehicle_brand: "", vehicle_model: "",
  vehicle_first_registration: "", vehicle_body_type: "", vehicle_fuel: "",
  vehicle_fiscal_power: "", vehicle_kw: "", vehicle_displacement: "",
  driving_type: "",
  vehicle_airbags: "", vehicle_tow_hook: false, vehicle_safety_devices: "",
  vehicle_storage: "", vehicle_anti_theft: "",
  concessione: "", subagency: "", next_installment_date: "", signing_amount: "",
  // 🆕 30/07/2026 — Campi Natante (attivi quando type === "natante")
  boat_maker_model: "", boat_hull_material: "", boat_length_m: "", boat_beam_m: "",
  boat_build_year: "", boat_registration_number: "",
  boat_engine_maker: "", boat_engine_model: "", boat_engine_serial: "",
  boat_engine_install: "", boat_engine_fuel: "", boat_engine_kw: "", boat_engine_mass_kg: "",
  boat_declaration_number: "", boat_declaration_date: "",
  // 🆕 30/07/2026 — Motori aggiuntivi (multi-motore)
  boat_engines_extra: [],
  first_installment_date: "", last_installment_paid_date: "", installment_dates: [], installment_amounts: {}, installment_paid_dates: {}, installment_paid_methods: {},
  contract_duration_years: 1,
  coverages: [],
  notify_expiry_client: true,
  category_id: "", notes: "",
  suspension_date: "", reactivation_deadline: "",
};

// Standard auto policy coverages (Italian RC Auto)
export const POLICY_COVERAGES = [
  { code: "rca", name: "Responsabilità Civile Auto" },
  { code: "valore_a_nuovo", name: "Indennità valore a nuovo" },
  { code: "incendio", name: "Incendio" },
  { code: "furto", name: "Furto" },
  { code: "assistenza_furto", name: "Assistenza Furto" },
  { code: "kasko", name: "Kasko" },
  { code: "garanzie_aggiuntive", name: "Garanzie Aggiuntive" },
  { code: "atti_vandalici", name: "Atti Vandalici / Eventi Naturali" },
  { code: "infortuni_conducente", name: "Infortuni del Conducente" },
  { code: "spese_mediche", name: "Spese mediche Macrolesioni" },
  { code: "assistenza", name: "Assistenza" },
  { code: "rapid_repair", name: "Rapid Repair" },
  { code: "tutela_giudiziaria", name: "Tutela Giudiziaria" },
];

export const FUEL_OPTIONS = ["Benzina", "Diesel", "GPL", "Metano", "Ibrido benzina", "Ibrido diesel", "Elettrico", "Altro"];
export const BODY_TYPE_OPTIONS = ["Berlina 2 volumi", "Berlina 3 volumi", "Station Wagon", "SUV", "Coupé", "Cabriolet", "Monovolume", "Furgone", "Altro"];
export const STORAGE_OPTIONS = ["Box / Garage", "Posto auto coperto", "Strada / All'aperto", "Cortile privato"];
export const AIRBAG_OPTIONS = ["Nessuno", "Solo guidatore", "Guidatore e Passeggero", "Front + Side", "Front + Side + Tendina"];
export const ANTI_THEFT_OPTIONS = ["Nessuno", "Immobilizer di serie", "Allarme", "Satellitare", "Doppio (immobilizer + allarme)"];

export const addMonthsISO = (dateStr, months) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const day = d.getUTCDate();
  d.setUTCDate(1);
  d.setUTCMonth(d.getUTCMonth() + months);
  const lastDay = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0)).getUTCDate();
  d.setUTCDate(Math.min(day, lastDay));
  return d.toISOString().slice(0, 10);
};

export const typeLabel = (v) => (POLICY_TYPES.find((t) => t.v === v) || {}).l || v;
